// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"241815bf","231":"a410e261","453":"eb80eccc"}[chunkId] + ".chunk.js";
};